import styled from "styled-components";

export const TitleFaturaTextValue = styled.span`
  color: #000;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 700;
  width: 100%;

  @media print {
    font-size: 9pt;
    font-weight: 700;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 12px;

  @media print {
    font-size: 8pt;
    font-weight: 700;
  }
`;

export const SpanTextBold = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: #000;

  @media print {
    font-size: 9pt;
  }
`;

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 12px;

  @media print {
    font-size: 8pt;
  }
`;

export const Dividers = styled.hr`
  border-top: 1px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
    margin-top: 10px;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;
  width: 150px;
  text-align: end;
  padding-right: 1%;

  @media print {
    font-size: 7pt;
  }
`;